/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import React from 'react';
import { Button, ButtonProps } from 'reactstrap';

export interface IconButtonProps extends ButtonProps {
  icon: string;
}

const IconButton = (props: IconButtonProps) => {
  const { onClick = () => { }, tooltip, color, className = '', disabled, outline = true } = props;

  const getIcon = () => {
    const icon = <i className={`fa ${props.icon}`} />;
    if (!tooltip) {
      return icon;
    }
    return <SimpleTooltip text={tooltip}>
      {icon}
    </SimpleTooltip>
  }

  return <Button
    outline={outline}
    disabled={disabled}
    color={color}
    {...props}
    className={`icon-button ${className}`}
    onClick={onClick}>
    {getIcon()}
  </Button>;
};

export default IconButton;
